import { Button } from 'common-front/src/designSystem/components/button';
import { RichSelect } from 'common-front/src/designSystem/components/richSelect/richSelect';
import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { useStateDebounce } from 'common-front/src/hooks/useStateDebounce';
import { useUsersSearch } from 'common-front/src/users/search/useUsersSearch';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { UsersInfoId } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import { isNonEmptyString } from 'common/src/util/string';
import * as React from 'react';

interface IDocumentsAssignedUserSelectorProps {
    downloadPath?: string;

    getPath(userInfoId: UsersInfoId): string;
}

export const DocumentsAssignedUserSelector = (props: IDocumentsAssignedUserSelectorProps) => {
    const {
        history,
        translate,
        params: { organizationId, eventId, userInfoId }
    } = useHeavent();
    const [name, nameDebounced, setName] = useStateDebounce('');
    const { usersInfosOptions, isLoading } = useUsersSearch({
        organizationId,
        eventId,
        hasSelected: true,
        nameDebounced,
        userInfoIds: [userInfoId]
    });

    return (
        <Flex
            align="center"
            css={{
                background: '$gray100',
                border: '1px solid $gray200',
                borderBottom: 'none',
                padding: '$3 $7'
            }}
            gap="4"
        >
            <Box font="gray900 textMd semiBold">{translate('aper_u_pour_le_81451')}</Box>

            <Box width={320}>
                <RichSelect
                    isSearchLoading={isLoading}
                    isSearchVisible={true}
                    searchElement={
                        <TextInput
                            icon="magnifying-glass"
                            name={name}
                            placeholder={translate('rechercher_un_m_05904')}
                            state="search"
                            onChange={setName}
                        />
                    }
                    values={[userInfoId]}
                    onChange={(newValue) => {
                        if (isNonEmptyArray(newValue)) {
                            history.replace(props.getPath(newValue[0]));
                        }
                    }}
                >
                    {usersInfosOptions}
                </RichSelect>
            </Box>

            {isNonEmptyString(props.downloadPath) && (
                <>
                    <Box css={{ flex: '1' }} />

                    <Box>
                        <Button color="white" to={props.downloadPath}>
                            {translate('t_l_charger_03283')}
                        </Button>
                    </Box>
                </>
            )}
        </Flex>
    );
};
